import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const CodeTabs = makeShortcode("CodeTabs");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><dl parentName="p"><dt parentName="dl"><inlineCode parentName="dt">{`status`}</inlineCode></dt><dd parentName="dl">{``}<em parentName="dd">{`Optional`}</em>{`. Describes the `}<inlineCode parentName="dd">{`status`}</inlineCode>{` of the Span/Transaction.`}</dd></dl></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`State`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`HTTP status code equivalent`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ok`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not an error, returned on success`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`200 and 2XX HTTP statuses`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`cancelled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The operation was cancelled, typically by the caller`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`499`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unknown`}</inlineCode>{` or `}<inlineCode parentName="td">{`unknown_error`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An unknown error raised by APIs that don't return enough error information`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`500`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`invalid_argument`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The client specified an invalid argument`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`400`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`deadline_exceeded`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The deadline expired before the operation could succeed`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`504`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`not_found`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Content was not found or request was denied for an entire class of users`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`404`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`already_exists`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The entity attempted to be created already exists`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`409`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`permission_denied`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The caller doesn't have permission to execute the specified operation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`403`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`resource_exhausted`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The resource has been exhausted e.g. per-user quota exhausted, file system out of space`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`429`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`failed_precondition`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The client shouldn't retry until the system state has been explicitly handled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`400`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`aborted`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The operation was aborted`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`409`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`out_of_range`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The operation was attempted past the valid range e.g. seeking past the end of a file`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`400`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unimplemented`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The operation is not implemented or is not supported/enabled for this operation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`501`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`internal_error`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Some invariants expected by the underlying system have been broken. This code is reserved for serious errors`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`500`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unavailable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The service is currently available e.g. as a transient condition`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`503`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`data_loss`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Unrecoverable data loss or corruption`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`500`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unauthenticated`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The requester doesn't have valid authentication credentials for the operation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`401`}</td>
        </tr>
      </tbody>
    </table>
    <div {...{
      "className": "code-tabs-wrapper"
    }}><CodeTabs mdxType="CodeTabs"><CodeBlock language="json" title="" filename="" mdxType="CodeBlock"><div parentName="div" {...{
            "className": "gatsby-highlight",
            "data-language": "json"
          }}><pre parentName="div" {...{
              "className": "language-json"
            }}><code parentName="pre" {...{
                "className": "language-json"
              }}><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"status"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"ok"`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span></code></pre></div></CodeBlock></CodeTabs></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      